export default "__VITE_ASSET__y28U_tw$__"